import { action as apiAction } from 'api/Api'
import {
  setDueDate,
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
}

const requestRemoveDueDate = (payload: Payload) => async dispatch => {
  const { cardId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setDueDate({
    id: cardId,
    dueDate: null
  }))

  try {
    await apiAction('RemoveDueDate', {
      cardId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRemoveDueDate
